import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getSchoolPreselectedProviderOrgs,
  setSchoolPreselectedProviderOrgs,
  type UpdateSchoolPreselectedProviderOrgsPayload,
} from '../../services';

// Query keys factory
export const perSiteKeys = {
  all: ['perSite'] as const,
  details: () => [...perSiteKeys.all, 'detail'] as const,
  detail: (schoolId: number | string) =>
    [...perSiteKeys.details(), schoolId] as const,
};

// Query pre-selected provider orgs for a school (site)
export function useSchoolPreselectedProviderOrgs(schoolId: number | string) {
  return useQuery({
    queryKey: perSiteKeys.detail(schoolId),
    queryFn: () => getSchoolPreselectedProviderOrgs(schoolId),
    enabled: !!schoolId,
  });
}

// Mutation to set / update pre-selected provider orgs for a school (site)
export function useSetSchoolPreselectedProviderOrgs() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateSchoolPreselectedProviderOrgsPayload) =>
      setSchoolPreselectedProviderOrgs(payload),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: perSiteKeys.detail(payload.school_id),
      });
      queryClient.invalidateQueries({ queryKey: perSiteKeys.all });
    },
  });
}
